"use client"

import React from 'react'
import { useRouter } from 'next/navigation'
import Image from 'next/image'

import { Layout, Typography, Avatar, Space, Popover, Button } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { useSession, signOut } from "next-auth/react"

import ModelCostCenter from './ModelCostCenter'

type Props = {}

const { Header } = Layout
const { Title, Text } = Typography

const ComponentHeader = (props: Props) => {
  const ref1 = React.useRef(null)
  const router = useRouter()
  const { data: session } = useSession()

  // const [openTour, setOpenTour] = React.useState<boolean>(false)
  const [openPopover, setOpenPopover] = React.useState<boolean>(false)
  const [openCostCenter, setOpenCostCenter] = React.useState<boolean>(false)
  const [departmentName, setDepartmentName] = React.useState<string>("")

  React.useEffect(() => {
    const isz_department = localStorage.getItem("isz_department") || ""
    setDepartmentName(isz_department)
  }, [])

  // Popover Open/Close
  const handleChangePopover = async (newOpen: boolean) => await setOpenPopover(newOpen)

  // Auth Sign Out
  const handleSignOut = async () => {
    await localStorage.removeItem("isz_cost_center")
    await localStorage.removeItem("isz_department")
    await localStorage.removeItem("isz_division")
    await localStorage.removeItem("isz_comp_code")

    await signOut()
  }

  // Handle choose cost center
  const handleCostCenter = async () => {

    await setOpenCostCenter(true)
    await setOpenPopover(false)
  }

  const handleCostCenterClose = async () => {
    const isz_department = await localStorage.getItem("isz_department") || ""
    await setDepartmentName(isz_department)

    await setOpenCostCenter(false)

    router.refresh()
  }

  return (
    <Header className='header'>
      <Image
        src={"/ispace.svg"}
        alt={"ispacezone"}
        width='180'
        height='40'
        priority={true}
      />

      <Space wrap align='center'>
        <div className='nomobile'>
          <Space>
            <Space.Compact direction="vertical" style={{ verticalAlign: 'middle' }}>
              <Text strong>{`Dept. : ${departmentName}`}</Text>
              {session && <Button className='color-primary' ref={ref1} onClick={handleCostCenter}>Department</Button>}
            </Space.Compact>
          </Space>
        </div>

        {session ? <Popover
          content={<Space direction="vertical" size="small" style={{ display: 'flex', textAlign: 'center' }}><Title level={5} className='title-non-margin'>{session.user?.name}</Title><div className='showmobile'><Text strong>{`Dept. : ${departmentName}`}</Text><br></br>{session && <Button className='color-primary' onClick={handleCostCenter}>Department</Button>}</div><Button type="primary" danger onClick={handleSignOut}>Log Out</Button></Space>}
          title=""
          trigger="click"
          open={openPopover}
          onOpenChange={handleChangePopover}
        ><Avatar size={64} src={session.user?.image} style={{ cursor: 'pointer' }} /></Popover> : <Avatar size={64} icon={<UserOutlined />} />}
      </Space>

      <ModelCostCenter stateOepn={openCostCenter} onModelClose={handleCostCenterClose} />
    </Header>
  )
}

export default ComponentHeader